import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { Controller, useFormContext } from 'react-hook-form';
import type { CreateOfferFormData } from '../types';

interface Props {
  disabled?: boolean;
}

export const AgreementTypeField = ({ disabled }: Props) => {
  const { control } = useFormContext<CreateOfferFormData>();
  const isMobile = useIsMobile();

  return (
    <Controller
      control={control}
      name="type"
      defaultValue="envelope"
      disabled={disabled}
      render={({ field }) => (
        <ToggleButtonGroup
          exclusive
          {...field}
          value={disabled ? undefined : field.value}
          size={isMobile ? 'small' : 'medium'}
          // TODO: remove once the pendo guide is disabled
          data-pendo-guide={disabled ? '' : 'agreement-type-toggle'}
        >
          <ToggleButton
            value="envelope"
            size={isMobile ? 'small' : 'medium'}
            sx={{
              '&.MuiToggleButton-root.MuiToggleButton-sizeSmall': {
                px: 1,
              },
            }}
          >
            Prepare to Send
          </ToggleButton>
          <ToggleButton
            value="attachment"
            size={isMobile ? 'small' : 'medium'}
            sx={{
              '&.MuiToggleButton-root.MuiToggleButton-sizeSmall': {
                px: 1,
              },
            }}
          >
            Attach Signed Agreement
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    />
  );
};
